import {
  ACTIVITYLOG_ALL,
  ACTIVITYLOG_LOADING,
  ACTIVITYLOG_ERROR,
  ACTIVITYLOG_RESET,
} from '../types';

import api from '../../../utils/functions/api';

export const activityLogAll = (params) => async (dispatch) => {
  try {
    dispatch({ type: ACTIVITYLOG_LOADING });
    const {
      module: mod = '',
      resourceType = '',
      submenu = '',
      action = '',
      startDate = '',
      endDate = '',
      actorUsername = '',
      page = 1,
      size = 50,
    } = params || {};

    const query = new URLSearchParams();
    if (mod) query.append('module', mod);
    if (resourceType) query.append('resourceType', resourceType);
    if (submenu) query.append('submenu', submenu);
    if (action) query.append('action', action);
    if (startDate) query.append('startDate', startDate);
    if (endDate) query.append('endDate', endDate);
    if (actorUsername) query.append('actorUsername', actorUsername);
    query.append('page', page);
    query.append('size', size);

    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/activity-log?${query.toString()}`,
    );
    if (status === 200) {
      dispatch({ type: ACTIVITYLOG_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: ACTIVITYLOG_ERROR });
    throw new Error(error);
  }
};

export const activityLogReset = () => (dispatch) => {
  dispatch({ type: ACTIVITYLOG_RESET });
};

/**
 * Generic function สำหรับบันทึก activity log จาก frontend
 * @param {Object} payload - { module, submenu, resourceType, action, description, ... }
 */
export const logAction = (payload) => async () => {
  try {
    await api.post(
      `${process.env.REACT_APP_API_URL}/activity-log/log-action`,
      payload,
    );
  } catch (error) {
    console.error('[Activity Log] Failed to log action:', error);
  }
};
